import React from "react";
import TableBody from "@mui/material/TableBody";
import TableContainer from "@mui/material/TableContainer";
import "../views/general.css";
import { useTranslation } from "react-i18next";


const ContactDetailsTable = () => {

    const { t } = useTranslation();

    return (
        <div>
            <TableContainer id="conttactTable" aria-label="Table displaying UK and IE phone contact">
                <table style={{ width: "auto", tableLayout: "auto" }}>
                    <TableBody style={{ width: "100%" }}>
                        <tr>
                            <td width="6%"
                                style={{
                                    padding: "0px", borderBottom: "none",
                                    fontWeight: "bold", border: "0px solid green", paddingLeft: 25
                                }}
                                align="left">
                                <span style={{ marginRight: "8px" }}>{'\u25CF'}</span>
                                {t("ContactUs.UK")}
                            </td>
                            <td
                                width="20%"
                                style={{
                                    padding: 0,
                                    borderBottom: "none",
                                    border: "0px solid green",
                                }}
                                align="left">
                                +44 800 783 9445
                            </td>
                        </tr>
                        <tr>
                            <td width="6%"
                                style={{
                                    padding: "0px", borderBottom: "none",
                                    fontWeight: "bold", border: "0px solid green", paddingLeft: 25
                                }}
                                align="left">
                                <span style={{ marginRight: "8px" }}>{'\u25CF'}</span>
                                {t("ContactUs.IE")}
                            </td>
                            <td
                                width="20%"
                                style={{
                                    padding: 0,
                                    borderBottom: "none",
                                    border: "0px solid green",
                                }}
                                align="left">
                                +353 1800554469
                            </td>
                        </tr>
                    </TableBody>
                </table>
            </TableContainer>
        </div>
    );
};
export default ContactDetailsTable;